import { IOvertimeRecordsEntity } from "../../typings"

const OvertimeWarningBanner = ({
  overtimeRecord,
  isApproving,
  warningIcon,
}: {
  overtimeRecord: IOvertimeRecordsEntity
  isApproving: boolean
  warningIcon: string
}) => {
  const duration =
    overtimeRecord?.overtimeStartTime && overtimeRecord?.overtimeEndTime
      ? getOvertimeDuration(
          overtimeRecord.overtimeStartTime,
          overtimeRecord.overtimeEndTime
        )
      : "—"

  return (
    <div className="bg-[#F8FAFC] border-2 border-[#E2E8F0] p-2 rounded-md flex items-center gap-2">
      <img
        src={warningIcon}
        width={25}
        height={25}
      />
      <span className="text-sm">
        This timesheet entry has an <strong>overtime of {duration}</strong>, do
        you want to {isApproving ? "approve" : "reject"} the overtime or only
        the hours within the predefined shift period?
      </span>
    </div>
  )
}

export default OvertimeWarningBanner

const getOvertimeDuration = (startTime: string, endTime: string): string => {
  const diffMs = new Date(endTime).getTime() - new Date(startTime).getTime()
  const totalMinutes = Math.floor(diffMs / 60000)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  if (hours === 0) return `${minutes}m`
  if (minutes === 0) return `${hours}h`
  return `${hours}h ${minutes}m`
}
